import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { MediaType } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import UserContext, { TwsUserParameters } from '../utils/user-context';

async function setupTwsUserParameters(): Promise<void> {

  const params: TwsUserParameters = {
    hasAccessToUserRegistration: true,
  }

  try {
    /** TO-DO Remove when jackson properly quote strings in JSON format */
    const options = {
      headers: {
        accept: MediaType.TEXT_PLAIN,
      }
    };
    const response = await HttpService.get(APPLICATION_ENDPOINTS.CREATE_NEW_USER_AVAILABLE, {}, options);
    params.hasAccessToUserRegistration = response.body !== 'N';
  } catch(error) {
    console.log(error);
  } finally {
    UserContext.twsUserParameters = params;
  }
}

export {
  setupTwsUserParameters,
};

